import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@material-ui/core';
import * as React from 'react';

interface Props {
  title: string;
  isOpen: boolean;
  handleClose: () => void;
};

export const BulkCodeResponseDialog: React.FC<Props> = (prop: Props) => {
  return (
      <Dialog 
        open={prop.isOpen}
        scroll={'paper'}
        onClose={prop.handleClose}>
        <DialogTitle>{prop.title}</DialogTitle>
        <DialogActions>
        <Button onClick={prop.handleClose}>Close</Button>
      </DialogActions>
      </Dialog>
    );
}